var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenEditThird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 18 16",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    transform: "translate(1.5 1.333373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.9825001.51746073v.00000007c.6900434.69048584.6900434 1.80951667-.0000001 2.5l-8.32249999 8.3225h-.00000001c-.2135725.2135575-.48116167.3650667-.77416667.4383333l-2.88583333.7216667.72166667-2.88583332.00000003-.00000014c.0732665-.293005.22477584-.56059417.43833334-.77416667l8.32333333-8.3225.00000006-.00000006c.69019917-.6899475 1.80896667-.6899475 2.49916667.00000013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.416667 4.583294-2.5-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.0000001 11.6666274-.9116667.9116667-.0000001.0000001c-1.00685 1.0065833-2.6389833 1.0065833-3.6458333-.0000002l-.0000001-.0000001c-1.0080833-1.0043833-2.6385833-1.0043833-3.64666663.0000001"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-1-2h20v20h-20z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEditThird);
export default __webpack_public_path__ + "static/media/pen-edit-third.c83f39a02626f318f9c24b033a065fb1.svg";
export { ForwardRef as ReactComponent };